module.exports = __webpack_public_path__ + "img/img10.eaa5f9f5.png";